var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineVideoAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 .25 0 .5-.02.74-.03.32-.25.58-.56.66a.742.742 0 0 1-.81-.31c-.03-.03-.09-.1-.13-.15-.72-.77-1.7-1.19-2.73-1.19a3.741 3.741 0 0 0-3.21 5.68c.18.3.4.58.65.8.04.03.07.06.09.08l.08.07c.23.19.34.52.25.81a.75.75 0 0 1-.63.54c-.22.02-.48.02-.73.02H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h5.03c-.01-.02-.02-.03-.03-.05-.49-.82-.76-1.76-.76-2.7 0-1.38.53-2.68 1.48-3.66a5.29 5.29 0 0 1 3.77-1.59c.98 0 1.94.27 2.75.78V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52 7.86c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18.96a.749.749 0 1 1 0 1.5H2.52z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77 6.97V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.86c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM14.73 6.52V2.11c0-.41.34-.75.75-.75s.75.34.75.75v4.41c0 .42-.33.75-.75.75-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.27 22.61c-.03-.02-.06-.04-.08-.06-.07-.06-.12-.1-.16-.14a.078.078 0 0 1-.04-.04 5 5 0 0 1-.97-1.17c-.49-.82-.76-1.76-.76-2.7 0-1.38.53-2.68 1.48-3.66a5.29 5.29 0 0 1 3.77-1.59c1.48 0 2.89.62 3.87 1.71.01.01.03.03.04.05.07.07.14.16.19.24.72.87 1.15 2.04 1.15 3.25 0 .44-.05.85-.15 1.24-.12.5-.32.99-.6 1.46a5.3 5.3 0 0 1-4.51 2.55c-1.18 0-2.33-.4-3.23-1.14zm.89-1.21c.66.55 1.46.84 2.34.84 1.31 0 2.53-.7 3.21-1.82.2-.33.34-.69.43-1.06.07-.28.11-.56.11-.87 0-.86-.3-1.69-.85-2.35l-.09-.12a.392.392 0 0 1-.08-.1c-.72-.76-1.7-1.18-2.73-1.18a3.741 3.741 0 0 0-3.21 5.68c.18.3.4.58.65.8.04.03.07.06.09.08l.06.05c.03.02.05.03.07.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.82 19.23c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.36a.749.749 0 1 1 0 1.5h-3.36z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 20.2v-3.36c0-.41.34-.75.75-.75s.75.34.75.75v3.36a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineVideoAdd);
export default __webpack_public_path__ + "static/media/vuesax-outline-video-add.ef9fc2186b50d12fd34d165a96a8a780.svg";
export { ForwardRef as ReactComponent };